<aca-libraries-base
  [currentFolderId]="'-mysites-'"
  [columns]="columns"
  [titleKey]="'APP.BROWSE.LIBRARIES.MENU.MY_LIBRARIES.TITLE'"
  [emptyTitleKey]="'APP.BROWSE.LIBRARIES.EMPTY_STATE.FILE_LIBRARIES.TITLE'"
  [emptySubtitleKey]="'APP.BROWSE.LIBRARIES.EMPTY_STATE.FILE_LIBRARIES.TEXT'"
/>
